import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../config/firebase';

const functions = getFunctions(app, 'us-central1');

export interface LifecycleActionResult {
  success: boolean;
  message?: string;
  restaurantId?: string;
  purgeEligibleAt?: string;
  recipientCount?: number;
  orderSummaryCount?: number;
  approved?: boolean;
}

export async function callHardDeleteRestaurant(
  restaurantId: string
): Promise<LifecycleActionResult> {
  const call = httpsCallable<{ restaurantId: string }, LifecycleActionResult>(
    functions,
    'hardDeleteRestaurant'
  );
  const result = await call({ restaurantId });
  return result.data;
}

export async function callRequestRestaurantPurge(
  restaurantId: string
): Promise<LifecycleActionResult> {
  const call = httpsCallable<{ restaurantId: string }, LifecycleActionResult>(
    functions,
    'requestRestaurantPurge'
  );
  const result = await call({ restaurantId });
  return result.data;
}

export async function callApproveRestaurantPurge(params: {
  restaurantId: string;
  alertId?: string;
  approve: boolean;
}): Promise<LifecycleActionResult> {
  const call = httpsCallable<
    { restaurantId: string; alertId?: string; approve: boolean },
    LifecycleActionResult
  >(functions, 'approveRestaurantPurge');
  const result = await call(params);
  return result.data;
}
